import { createPerimeter } from 'vue-kindergarten';
import { isRole } from '../utilities/roleUtilities';

export const BannersPerimeter = createPerimeter({
    purpose: 'banners',

    can: {
        read () {
            return isRole.admin(this.child)
                || isRole.key_account(this.child);
        },
        // only admin can edit product
        edit () {
            return isRole.admin(this.child)
                || isRole.key_account(this.child);
        },

        // only admin can edit product
        update () {
            return isRole.admin(this.child)
                || isRole.key_account(this.child);
        },

        // if user can update articles then she can also destroy them
        destroy () {
            return this.isAllowed('update');
        }
    }

});
